export default {"src":"/_next/static/media/coffee-maker.015122e7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};